
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConningIec as ObiConningIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-conning-iec.js';
 
 
 

 
 export const ObiConningIec = createComponent({
   react: React,
   tagName: 'obi-conning-iec',
   elementClass: ObiConningIecElement,
   events: {
     
   }
  });
 
 